import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Component that scrolls to top of page when route changes
 */
export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Use instant for immediate scroll, or "smooth" for animated
    });
  }, [pathname]);

  return null;
};
